import { render, staticRenderFns } from "./AxPrivItem.vue?vue&type=template&id=319ff48f&scoped=true"
import script from "./AxPrivItem.vue?vue&type=script&lang=ts"
export * from "./AxPrivItem.vue?vue&type=script&lang=ts"
import style0 from "./AxPrivItem.vue?vue&type=style&index=0&id=319ff48f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319ff48f",
  null
  
)

export default component.exports